import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Error } from '../Error';
import { Input } from '../Input';
import { Label } from '../Label';
import { FilterActions } from './FilterActions';
import styles from './styles.scss';
export var FilterDate = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterDate, _React$Component);

  var _super = _createSuper(FilterDate);

  function FilterDate(props) {
    var _this;

    _classCallCheck(this, FilterDate);

    _this = _super.call(this, props);

    _this.handleApply = function () {
      _this.props.onApplyFilter({
        minValue: _this.state.minValue,
        maxValue: _this.state.maxValue
      });
    };

    _this.handleClear = function () {
      return _this.props.onClearFilter();
    };

    _this.handleMinChange = function (value) {
      _this.setState({
        minValue: value
      });
    };

    _this.handleMaxChange = function (value) {
      return _this.setState({
        maxValue: value
      });
    };

    _this.handleDateValidation = function (isDateValid) {
      if (!isDateValid) {
        _this.setState({
          invalidDate: true
        });
      } else {
        _this.setState({
          invalidDate: false
        });
      }
    };

    _this.state = _objectSpread(_objectSpread({}, props.filterState), {}, {
      invalidDate: false
    });
    return _this;
  }

  _createClass(FilterDate, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          minValue = _this$state.minValue,
          maxValue = _this$state.maxValue;
      var validateDateRange = minValue && minValue.length > 0 && maxValue && maxValue.length > 0;
      var invalidDateRange = validateDateRange && new Date(this.state.maxValue).getTime() < new Date(this.state.minValue).getTime();
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: styles.formItem
      }, React.createElement(Label, null, "From"), React.createElement(Input.Date.Small, {
        dataTest: "start-date-input",
        value: this.state.minValue,
        onChange: this.handleMinChange,
        onDateValid: this.handleDateValidation,
        disabled: this.props.filtersDisabled
      })), React.createElement("div", {
        className: styles.formItem
      }, React.createElement(Label, null, "To"), React.createElement(Input.Date.Small, {
        dataTest: "end-date-input",
        value: this.state.maxValue,
        onChange: this.handleMaxChange,
        onDateValid: this.handleDateValidation,
        disabled: this.props.filtersDisabled
      })), invalidDateRange && React.createElement(Error, {
        dataTest: "end-date-error-label"
      }, "Enter a date that is later than the From date."), React.createElement(FilterActions, {
        disableApplyButton: !this.state.minValue && !this.state.maxValue || invalidDateRange || this.state.invalidDate || this.props.filtersDisabled,
        onClearFilter: this.handleClear,
        onApplyFilter: this.handleApply
      }));
    }
  }]);

  return FilterDate;
}(React.Component);